import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
import { renderRowCreatedAt } from 'utils/renderTableCell';
import { useState } from 'react';
import { RejectHistory } from 'components/dialog/RejectHistory';
import { renderStatus } from 'utils/webinar/getStatus';
import { PATH_DASHBOARD } from 'routes/paths';
import { useWebinarRequest } from 'hooks/useWebinarRequest';
import { useSnackbar } from 'notistack';
import { TableMoreMenu } from 'components/Table';

export const NewWebinarRow = ({ row, index, type = 'NEW' }) => {
  const [openRejectHistory, setOpenRejectHistory] = useState(false);
  const [stopWebinarOpen, setStopWebinarOpen] = useState(false);
  const [messageModalOpen, setMessageOpen] = useState(false);
  const [adminMessage, setAdminMessage] = useState('');
  const [messageType, setMessageType] = useState('warning');
  const { apiCall } = useWebinarRequest();
  const { enqueueSnackbar } = useSnackbar();

  const onStopWebinar = () => {
    apiCall({
      url: '/admin/webinar/forceEnd',
      method: 'POST',
      data: {
        webinarID: row?._id,
      },
    }).then(() => {
      enqueueSnackbar('با موفقیت متوقف شد', { variant: 'success' });
      setStopWebinarOpen(false);
      setTimeout(() => {
        window?.location.reload();
      }, 1000);
    });
  };

  const onSendMessage = () => {
    apiCall({
      url: '/admin/webinar/messageToPresenter',
      method: 'POST',
      data: {
        webinarID: row?._id,
        type: messageType,
        message: adminMessage,
      },
    }).then(() => {
      enqueueSnackbar('ارسال شد', { variant: 'success' });
      setMessageOpen(false);
    });
  };

  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="center">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?.title || 'عنوان نامشخص'}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{renderRowCreatedAt('fa-IR', row?.createdAt)}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{renderRowCreatedAt('fa-IR', row?.liveAt)}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{renderRowCreatedAt('fa-IR', row?.liveAt, false, true)}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?._id?.split('_')[0]}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?.products?.length > 0 ? 'دارد' : 'ندارد'}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?.siteDomain || '-'}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?.category?.name || '-'}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{renderStatus(row?.finished?.byAdmin ? 'STOPPED' : row?.status)}</Typography>
        </TableCell>
        {/* <TableCell align="center">
          <a
            href={`https://${row?.status !== 4 ? row?.host : row?.host.split('!')[2]}.aff.bizmlm.ir`}
            target="_blank"
            rel="noreferrer"
          >
            <Typography>{row?.status !== 4 ? row?.host : row?.host.split('!')[2]}</Typography>
          </a>
        </TableCell> */}
        <TableCell align="center" sx={{ display: 'flex', justifyContent: 'center' }}>
          {type === 'ON_BOARD' ? (
            <>
              <TableMoreMenu
                options={[
                  {
                    title: 'ورود به وبینار',
                    onChange: () => {
                      window.location.href = `${process.env.REACT_APP_USER_WEBSITE_BASE_URL.replace(
                        '{DOMIAN}',
                        row?.siteDomain
                      )}/webinar/${row?._id}`;
                    },
                  },
                  { title: 'ارسال پیام', onChange: () => setMessageOpen(true) },
                  { title: 'توقف وبینار', onChange: () => setStopWebinarOpen(true) },
                ]}
                onChange={(option) => option?.onChange()}
              />
            </>
          ) : (
            <div aria-hidden onClick={() => window?.open(PATH_DASHBOARD.webinar.detail(row?._id), '_blank')}>
              <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
            </div>
          )}
        </TableCell>
      </TableRow>
      <RejectHistory
        open={openRejectHistory}
        onClose={() => setOpenRejectHistory(false)}
        content={row?.status === 3 ? row?.activation : row?.deactivation}
        status={row?.status}
      />
      <Dialog open={stopWebinarOpen} onClose={() => setStopWebinarOpen(false)}>
        <Box sx={{ minWidth: 600, padding: '1rem' }}>
          <DialogTitle>
            <Stack flexDirection="row" alignItems="center" justifyContent="space-between">
              <Box onClick={() => setStopWebinarOpen(false)}>
                <SvgIconStyle src="/icons/close_square_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
              </Box>
              <Typography fontSize={20} fontWeight={700}>
                توقف اظطراری وبینار
              </Typography>
              <div />
            </Stack>
          </DialogTitle>
          <Typography sx={{ textAlign: 'center', fontWeight: 700 }}>از توقف اظطراری وبینار اطمینان دارید؟</Typography>
          <DialogActions>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} width={'100%'} gap={2} mt={2}>
              <Button variant="contained" color="error" onClick={() => onStopWebinar()}>
                توقف وبینار
              </Button>
              <Button variant="outlined" color="primary">
                بازگشت
              </Button>
            </Stack>
          </DialogActions>
        </Box>
      </Dialog>
      <Dialog open={messageModalOpen} onClose={() => setMessageOpen(false)}>
        <Box sx={{ minWidth: 600, padding: '1rem' }}>
          <DialogTitle>
            <Stack flexDirection="row" alignItems="center" justifyContent="space-between">
              <Box onClick={() => setMessageOpen(false)}>
                <SvgIconStyle src="/icons/close_square_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
              </Box>
              <Typography fontSize={20} fontWeight={700}>
                ارسال پیام به برگزار کننده وبینار
              </Typography>
              <div />
            </Stack>
          </DialogTitle>
          <Select
            fullWidth
            sx={{ my: 2 }}
            label="نوع پیام"
            value={messageType}
            onChange={(e) => setMessageType(e.target.value)}
          >
            <MenuItem value="error">اخطار</MenuItem>
            <MenuItem value="warning">توجه</MenuItem>
          </Select>
          <TextField
            label="متن پیام"
            value={adminMessage}
            onChange={(e) => setAdminMessage(e?.target?.value)}
            fullWidth
            multiline
            minRows={3}
          />
          <DialogActions>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} width={'100%'} gap={2} mt={2}>
              <Button variant="contained" color="success" onClick={() => onSendMessage()}>
                ارسال پیام
              </Button>
              <Button variant="outlined" color="primary" onClick={() => setMessageOpen(false)}>
                بازگشت
              </Button>
            </Stack>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};
